// extracted by mini-css-extract-plugin
export default {"root":"Resizable_root_ulJzv","top":"Resizable_top_j6ujJ","right":"Resizable_right_MdvJr","bottom":"Resizable_bottom_y2fkK","left":"Resizable_left_K3Otr"};